import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: Quotas is empty
 */
export class ArchivoCuotasVacioParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("Quotas is empty");
    }

    public traducir(): string {
        return "El archivo de muestras esta vacio";
    }
}
